import { rest } from 'msw'

import { VendorPaymentMethodApiModelStub } from '../api-models/stubs/VendorPaymentMethodApiModel.stub'
import { type VendorPaymentMethodApiModel } from '../api-models/VendorPaymentMethodApiModel'

export const mockCreateVendorPaymentMethodSuccess = (
  paymentMethod: VendorPaymentMethodApiModel = VendorPaymentMethodApiModelStub.build()
) => {
  return rest.post(`/api/v2/ap/vendor-payment-methods/`, (_, res, ctx) => {
    return res.once(ctx.status(201), ctx.json({ data: paymentMethod }))
  })
}
